import { Record as record } from 'immutable';

import { construct, fields, resolveAll } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';


const fieldSchema = {
    id: [fields.string],
    comments: [fields.bool],
    allowPreviousUpload: [fields.bool],
    onlyFor: [resolveAll.with(fields.string)]
};

export default class EvidenceType extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(EvidenceType, json, getResolvers(fieldSchema));
    }
}




// WEBPACK FOOTER //
// ./delay-repay/src/records/compensation/EvidenceType.js